export default __webpack_public_path__ + "static/Reactathon_Sept_2018-db7c7a976990fa56abc963874e3271a8.jpeg";